const DeviceList = () => import('Views/device/device-list');
const DeviceAddEdit = () => import('Views/device/device-addEdit');
const DeviceDetail = () => import('Views/device/device-detail');
const DeviceAlarm = () => import('Views/device/device-alarm');
const DeviceMaintenanceList = () => import('Views/device/device-maintenance-list');
const DeviceTableList = () => import('Views/device/device-table-list');
const DeviceMaintenance = () => import('Views/device/device-maintenance');
const DeviceMaintenanceAdd = () => import('Views/device/device-maintenance-add');
const DeviceMaintenanceDetail = () => import('Views/device/device-maintenance-detail');

export default [
  { path: '/device-list', component: DeviceList },
  { path: '/device-add', component: DeviceAddEdit },
  { path: '/device-edit/:id', component: DeviceAddEdit },
  { path: '/device-detail/:id', component: DeviceDetail },
  { path: '/device-alarm/:id', component: DeviceAlarm },
  { path: '/device-maintenance-list', component: DeviceMaintenanceList },
  { path: '/device-table-list', component: DeviceTableList },
  { path: '/device-maintenance', component: DeviceMaintenance },
  { path: '/device-maintenance-add', component: DeviceMaintenanceAdd },
  { path: '/device-maintenance-detail/:id', component: DeviceMaintenanceDetail },
];



// WEBPACK FOOTER //
// ./src/router/device.js